import { FLAG_TONE } from '../lib/constants.js';

export function ConfidencePill({ confidence }) {
  if (!confidence) return null;
  const tone = confidence === 'High' ? FLAG_TONE.green
            : confidence === 'Medium' ? FLAG_TONE.yellow
            : confidence === 'Low' ? FLAG_TONE.red
            : FLAG_TONE.gray;
  return (
    <span style={{
      display: 'inline-block', padding: '4px 10px', borderRadius: 12,
      background: tone.bg, color: tone.text, border: `1px solid ${tone.bar}`,
      fontWeight: 600, fontSize: 12,
    }}>{confidence}</span>
  );
}
